import { render, staticRenderFns } from "./ExchangeButton.vue?vue&type=template&id=02f12362"
import script from "./ExchangeButton.vue?vue&type=script&lang=js"
export * from "./ExchangeButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports